export const ProspectBasePath = '/prospect';
export const TourBasePath = `${ProspectBasePath}/tour`;
export const FaqBasePath = `${ProspectBasePath}/faq`;

export const propertySlugCapture = ':propertySlug';
export const guestCardGuidCapture = ':guestCardGuid?';
export const tourGuidCapture = ':tourGuid';



// WEBPACK FOOTER //
// ./src/components/pages/prospect/ProspectRouteValues.ts